<template>
  <div class="holiday">
    <navbarStaff />
    <div class="container">
      <FullCalendar
        :options="calendarOptions"
        ref="fullCalendar"
        :available-dates="{ start: new Date(), end: null }"
      />
    </div>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import navbarStaff from "../layouts/navbar_staff.vue";
import "@fullcalendar/core/vdom";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
export default {
  components: { navbarStaff, FullCalendar },
  data(){
    return{
         calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        dateClick: this.handleDateClick,
        events: [
          {},
          // title: 'event 2', date: '2019-04-02'
        ],
      },
      attributes: [
        {
          key: "today",
          highlight: true,
          dates: new Date(),
        },
    ],
     dateTime: new Date(),
    }
  }
};
</script>

<style scoped>
.holiday {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
</style>
